export default __webpack_public_path__ + "static/media/background.24b44bbc.svg";